import { PcmpDisburseVerifyQueue } from '../components/PcmpDisburseVerify/PcmpDisburseVerifyQueue';

export function PcmpDisburseVerifyPage() {
  return <PcmpDisburseVerifyQueue />;
}
